import { GTMEvent } from '../GTM'
import { itemHasKey, isNonNullRecord } from '@corratech/pylot-utils'

type GTMCheckoutActionField = {
    step: number
    option?: string
}

const isValidActionField = (data: unknown): data is GTMCheckoutActionField => {
    if (!isNonNullRecord(data)) {
        return false
    }
    return itemHasKey(data, 'step') && !isNaN(Number(data.step))
}

export const formatCheckoutActionField = (
    data: unknown
): GTMCheckoutActionField => {
    if (!isValidActionField(data)) {
        console.info('Invalid checkout option GTM data')
        return { step: 1, option: '' }
    }
    data.option = String(data.option)
    return data
}

export const pushCheckoutStep = (data: Record<string, unknown>): GTMEvent => {
    return {
        event: 'checkout',
        ecommerce: {
            checkout: {
                actionField: formatCheckoutActionField(data.actionField),
                products: data?.productsDetails ?? []
            }
        },
        _clear: true
    }
}
